export const INIT_inputQuantity = () => {
    window.addEventListener('click', event => {
        const target = event.target;

        if (target.classList.contains('js--input-quantity--minus') || target.classList.contains('js--input-quantity--plus')) {
            const field = target.closest('.g-input-quantity');
            const input = field.querySelector('input');
            const limitMin = parseInt(input.min);
            const limitMax = parseInt(input.max);

            target.blur();

            if (target.classList.contains('js--input-quantity--minus')) {
                updateQuantity(input, limitMin, '<');
            }

            if (target.classList.contains('js--input-quantity--plus')) {
                updateQuantity(input, limitMax, '>');
            }

            const btnMinus = field.querySelector('.js--input-quantity--minus');
            const btnPlus = field.querySelector('.js--input-quantity--plus');
            const value = parseInt(input.value);

            btnMinus.disabled = value > limitMin ? false : true;
            btnPlus.disabled = value < limitMax ? false : true;
        }
    });

    function updateQuantity(input, limit, direction) {
        if (!input.disabled) {
            const value = parseInt(input.value);

            input.readOnly = true;

            if (value !== limit) {
                input.value = direction === '>' ? (value + 1) : (value - 1);
            }
        }
    }
};
